import AddAndRemoveItemButton from "./AddAndRemoveItemButton";
import NoStockButton from "./NoStockButton";

const CheckStockAndChangeButton = (props: any) => {
  return (
    <div>
      {props.items.stock ? (
        <div className={`${props.parentStyles} mx-1`}>
          <AddAndRemoveItemButton
            data={props.items}
            styles={props.childStyles}
            variant={props.variant}
            large={props.large}
            showLabel={props.showLabel}
          />
        </div>
      ) : (
        <NoStockButton large={props.large} />
      )}
    </div>
  );
};

export default CheckStockAndChangeButton;
